import type { FleetFuelMatchStatus } from '@gb-ticket/shared-types';

import { Badge } from '@/components/ui/badge';
import { FLEET_FUEL_MATCH_STATUS_LABELS } from '@/products/fleet/features/fleet-labels';

export function FleetFuelMatchBadge({ status }: { status: FleetFuelMatchStatus }) {
  const label = FLEET_FUEL_MATCH_STATUS_LABELS[status];
  const variant = status === 'exception' ? 'destructive' : 'secondary';
  return <Badge variant={variant}>{label}</Badge>;
}
